module.exports = __webpack_public_path__ + "img/designing_for_behaviour_change.042c76d6.jpg";